module.exports = __webpack_public_path__ + "img/section1_tab3_img.ef6cfca1.svg";